import App from './App';
import Header from './component/Header';
import Auth from './component/Auth';
import Libr from './component/Libr';
import Stat from './component/Stat';

const routes = [
  { path: '/',
    component: App
  },
  { path: '/libr',
    component: Libr,
    routes: [
      { path: '/libr/bus',
        component: Libr
      },
      { path: '/tacos/cart',
        component: Libr
      }
    ]
  },
  { path: '/auth',
    component: Auth 
  },
  { path: '/stat',
    component: Stat 
  }
]

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js